import * as types from '../actions/types'

const defaultState = {
  feedbackTitle: null,
  feedbackMessage: null,
  feedbackType: null,
  styleFeedbackType: 'info',
  messageTimestamp: null,
  btnLabel: null,
  reportDownloadProgress: null,
  reportDownloadFile: null,
  reportIsLoading: false,
}

const initialState = {
  isApplicationLoading: false,
  isMarketLoading: false,
  isHiredLoading: false,
  isInTransitLoading: false,
  isDeliveredLoading: false,
  isModalLoading: false,
  ...defaultState,
}

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case types.IS_MARKET_LOADING:
      return { ...state, isMarketLoading: payload }
    case types.IS_HIRED_LOADING:
      return { ...state, isHiredLoading: payload }
    case types.IS_IN_TRANSIT_LOADING:
      return { ...state, isInTransitLoading: payload }
    case types.IS_DELIVERED_LOADING:
      return { ...state, isDeliveredLoading: payload }
    case types.IS_APPLICATION_LOADING:
      return { ...state, isApplicationLoading: payload }
    case types.IS_MODAL_LOADING:
      return { ...state, isModalLoading: payload }
    case types.SHOW_USER_FEEDBACK:
      return {
        ...state,
        ...defaultState,
        ...payload,
        feedbackMessage: payload.feedbackMessage,
        feedbackType: payload.feedbackType,
        feedbackTitle: payload.feedbackTitle,
        styleFeedbackType: payload.styleFeedbackType,
        messageTimestamp: payload.messageTimestamp,
        status: payload.status,
      }
    case types.USER_LOGOUT:
      return {
        ...state,
        feedbackMessage: 'Deslogado com sucesso.',
        feedbackType: 'MESSAGE',
        feedbackTitle: null,
        styleFeedbackType: 'success',
        messageTimestamp: new Date().getTime(),
      }

    case types.REPORT_GENERATION_IS_LOADING:
      return {
        ...state,
        reportIsLoading: payload,
        reportDownloadProgress: null,
        reportDownloadFile: null,
      }
    case types.REPORT_UPDATE_PROGRESS:
      return {
        ...state,
        reportDownloadProgress: payload,
      }

    case types.REPORT_HISTORY_FINISHED:
      return {
        ...state,
        reportDownloadFile: payload,
        reportIsLoading: false,
      }
    case types.CLEAR_DOWNLOADED_REPORT:
      return {
        ...state,
        reportDownloadProgress: null,
        reportDownloadFile: null,
        reportIsLoading: false,
      }
    case types.STORE_KEYCLOAK_INSTANCE:
      return { ...state, keycloak: payload }
    default:
      return state
  }
}
